import React from 'react';
import { connect } from 'tanok';
import {
    BESIDA_ROLE_BUYER
} from '@evo/chat-core';
import { Config } from './../../../../../../../core/config';

import { toJS } from '../../../../../../helpers/ImmutableToJS';
import { ClientRecommendationMsg } from './client';
import { CompanyRecommendationMsg } from './company';

function getSafetyRecommendationUrl(){
    let url = 'https://prom.ua/security_guide';
    const { IS_BEL_PROM } = Config.data.appState;
    if (IS_BEL_PROM) {
        url = 'https://deal.by/security_guide';
    }
    return url;
}

const SafetyRecommendationView = ({ userRole }) => {
    const isInBuyerRole = userRole === BESIDA_ROLE_BUYER;
    const safetyRecommendationUrl = getSafetyRecommendationUrl();
    return isInBuyerRole
        ? <ClientRecommendationMsg safetyRecommendationUrl={safetyRecommendationUrl} />
        : <CompanyRecommendationMsg safetyRecommendationUrl={safetyRecommendationUrl} />;
};

const mapStateToProps = (state) => {
    return {
        userRole: state.get('userRole'),
        locale: state.get('locale')
    };
};

export const SafetyRecommendationMsg = connect(mapStateToProps)(toJS(SafetyRecommendationView));
